// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__a5329","innerContainer":"sidebar_innerContainer__ab6ea"};